module.exports = __webpack_public_path__ + "img/chess_chinesechessred3.5a4450fe.png";